// Native share is only worth offering where it opens a real OS sheet — mobile
// Safari/Chrome. The `typeof navigator.share` check also covers the Web Share
// API being a secure-context feature, so it reads as undefined over plain http
// (LAN dev servers, tunnelled device-testing origins) and callers fall back.
export const canNativeShare = (): boolean =>
  typeof navigator !== "undefined" &&
  typeof navigator.share === "function" &&
  /iPhone|iPad|iPod|Android/i.test(navigator.userAgent) &&
  navigator.maxTouchPoints > 0;
